import { render } from "./PalletSimulationPage.vue?vue&type=template&id=06bf555f&scoped=true&ts=true"
import script from "./PalletSimulationPage.vue?vue&type=script&lang=ts"
export * from "./PalletSimulationPage.vue?vue&type=script&lang=ts"

import "./PalletSimulationPage.vue?vue&type=style&index=0&id=06bf555f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bf555f"]])

export default __exports__